"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeProduct = void 0;
const products_1 = require("@/store/ducks/products");
const products_2 = require("@/services/products");
const listProductsUseCase_1 = require("./listProductsUseCase");
function removeProduct(productId) {
    return async (dispatch) => {
        dispatch(products_1.deleteProduct);
        try {
            await (0, products_2.deleteProductService)(productId);
            dispatch((0, products_1.deleteProductSuccess)());
            await (0, listProductsUseCase_1.listProducts)()(dispatch);
        }
        catch (e) {
            dispatch((0, products_1.deleteProductError)());
        }
    };
}
exports.removeProduct = removeProduct;
